import { useState, useEffect } from 'react';
import axios from 'axios'
import { toast } from 'react-toastify';
import { commonMessage, statusCodes } from '../../../Constants/generalConfig';
import { stateList, stateDelete, logOutApi } from '../../../Context/api';
import { useNavigate } from 'react-router-dom';

const UseState = () => {
    const [stateData, setStateData] = useState([])
    const [stateId, setStateId] = useState('')
    const [filter, setFilter] = useState({
        state: '',
        country: ''
    })
    const [count, setCount] = useState(1)
    const [page, setPage] = useState(1)
    const PER_PAGE = 10
    const [spinner, setSpinner] = useState(false)
    const adminData = JSON.parse(localStorage.getItem('adminData'));
    const navigate = useNavigate()

    useEffect(() => {
        stateLists()
        setSpinner(true)
    }, [page])

    const logOutFun = () => {
        axios.post(logOutApi(), { deviceId: adminData.deviceId }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                localStorage.removeItem('adminData')
                navigate('/')
            }
        })
    }
    const stateLists = () => {
        const data = {
            id: adminData.userId,
            isDeleted: true,
            searchName: filter.state,
            searchCountry: filter.country,
            sortValue: 'name',
            sortOrder: -1,
            page: page,
            count: PER_PAGE
        }
        axios.post(stateList(), { ...data }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setStateData(resp.data)
                setSpinner(false)
                setCount(resp.data.totalCount);
            }
            else if (resp.data.code === statusCodes.tokenExpire) {
                logOutFun()
            }
            else {
                setStateData([])
                setSpinner(false)
            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
                setSpinner(false)
            })
    }
    const deleteState = () => {
        axios.post(stateDelete(), { id: stateId }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                toast.success(resp.data.message)
                stateLists()
            }
            else if (resp.data.code === statusCodes.tokenExpire) {
                logOutFun()
            }
            else {
                toast.error(resp.data.message)
            }
        })
    }
    const handleChange = (e) => {
        const { name, value } = e.target
        setFilter((pre) => ({
            ...pre,
            [name]: value
        }))
    }
    return {
        stateData,
        page,
        count,
        PER_PAGE,
        spinner,
        filter,
        stateLists,
        setStateId,
        setPage,
        deleteState,
        handleChange,
    }
}

export default UseState